import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class AdminMenu extends Component {
    constructor() {
        super();

        if (!Comm.ValidSession()) return;

        this.state = {
            Translation: Translation,
        };
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        return (
            <div className="btn-toolbar">
                {Context.HasRight("rusers") && (
                    <Link className="btn btn-primary menuButton" to="/users">
                        <i className="fas fa-user"></i>
                        <p>{Translation.Trans("users")}</p>
                    </Link>
                )}
                {Context.HasRight("rgroups") && (
                    <Link className="btn btn-primary menuButton" to="/groups">
                        <i className="fa fa-users"></i>
                        <p>{Translation.Trans("groups")}</p>
                    </Link>
                )}
                <Link className="btn btn-primary menuButton" to="/changepassword">
                    <i className="fa fa-asterisk"></i>
                    <p>{Translation.Trans("changepassword")}</p>
                </Link>
            </div>
        );
    }
}

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/pages/adminmenu.js